import React from "react";
import CreateInfoModal from "../create/InfoModal/CreateInfoModal";
import { useT, UT } from "@transifex/react/dist";
import { InnerTextWrapper, CancelText } from "./StyledComponents";

interface CancelCreateExerciseModalProps {
    isOpen: boolean;
    closeModalCallback: () => void;
    continueCallback: () => void;
    text: string;
}

const CancelCreateExerciseModal: React.FC<CancelCreateExerciseModalProps> = (props) => {

    const t = useT();
    const t_cancel = t("Cancel", { _tags: "CreateTest,CancelCreateExercise" });
    const t_agree = t("Yes", { _tags: "CreateTest,CancelCreateExercise" });

    function continueAction() {
        props.continueCallback();
        props.closeModalCallback();
    }

    return (
        <CreateInfoModal
            isOpen={props.isOpen}
            onRequestClose={props.closeModalCallback}
            continueAction={continueAction}
            continueText={t_agree}
            cancelText={t_cancel}
            cancelAction={props.closeModalCallback}
        >
            <InnerTextWrapper>
                <CancelText>
                    <UT
                        _str={props.text}
                        _inline
                        _tags="CreateTest,CancelCreateExercise"
                    />
                </CancelText>
            </InnerTextWrapper>
        </CreateInfoModal>
    );
};

export default CancelCreateExerciseModal;
